<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>

<div id="header-container" class="ml-3 mr-3">
  <h1 id="header-text">Online Edit</h1>
  <div class="d-flex gap-8">

    <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="select-button" class="action-button"
            (click)="updateForecast()" [disabled]="!isUpdateEnabled"
            *ngIf="!stateService.selectedScenario.isEditLocked">
      Update Scenario
    </button>
  </div>
</div>


<div mat-dialog-content class="d-flex flex-column gap-8 mh-100">
  <div class="d-flex gap-8 justify-content-between">
    <div class="d-flex align-items-center flex-wrap gap-8">
      <mat-icon fontIcon="lock"
                *ngIf="stateService.selectedScenario.isEditLocked"
                matTooltip="Edit Locked">
      </mat-icon>
      <h2 class="m-0 font-weight-bold">
        {{ stateService.selectedScenario.vehScenId }} - {{ stateService.selectedScenario.vehScenName }}
      </h2>
    </div>


    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Displayed Columns</mat-label>
      <fab-multiselect
        [(ngModel)]="displayedColumns.selectedOptions"
        (ngModelChange)="onColumnUpdate()"
        [options]="displayedColumns.options"
      ></fab-multiselect>
    </mat-form-field>
  </div>
  <ag-grid-angular
    style="height: 100%;"
    class="ag-theme-quartz"
    [rowData]="tableData"
    [columnTypes]="columnTypes"
    [pagination]="true"
    [paginationPageSize]="pageSize"
    [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
    [autoSizeStrategy]="autoSizeStrategy"
    (gridReady)="onGridReady($event)"

    (cellMouseDown)="copyPaste.cellMouseDown($event)"
    (cellMouseOver)="copyPaste.cellHover($event,gridApi)"
    (mouseup)="copyPaste.mouseReleased(gridApi)"
    (keydown)="copyPaste.keyboardEvent($event,gridApi.getColumnDefs(),gridApi,pageSize)"
    (paste)="copyPaste.pasteEvent($event,gridApi.getColumnDefs(),gridApi,pageSize)"
    [stopEditingWhenCellsLoseFocus]="true"
    (cellEditingStarted)="isUpdateEnabled = false;"
    (cellEditingStopped)="isUpdateEnabled = true;"
  />
</div>

